module.exports = __webpack_public_path__ + "img/partner7.d992d435.png";